import { isBrowser, parseCookies } from "@wbly/common";

export type CookieType =
  | "necessary"
  | "analytics"
  | "advertisement"
  | "functional"
  | "performance"
  | "other";

export const COOKIEYES_EVT = "cookieyes_consent_update";

export type CookieYesData = {
  accepted: CookieType[];
  rejected: CookieType[];
};

type CookieYesUpdateEvent = CustomEvent<CookieYesData>;

export function onConsentChange(cb: (data: CookieYesData) => void) {
  const handler = (evt: CookieYesUpdateEvent) => {
    cb(evt.detail);
  };
  document.addEventListener(COOKIEYES_EVT, handler);
  return () => document.removeEventListener(COOKIEYES_EVT, handler);
}

export function hasCookieConsent(type: CookieType) {
  if (!isBrowser()) return false;
  return parseCookies(document.cookie)[`cookieyes-${type}`] === "yes";
}
